import { render, staticRenderFns } from "./DictionariesSettings.vue?vue&type=template&id=0c822012&scoped=true"
import script from "./DictionariesSettings.vue?vue&type=script&lang=js"
export * from "./DictionariesSettings.vue?vue&type=script&lang=js"
import style0 from "./DictionariesSettings.vue?vue&type=style&index=0&id=0c822012&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c822012",
  null
  
)

export default component.exports